import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class UniversalScannerBackService {
  private closeScanner?: () => void;

  register(closeScanner: () => void): () => void {
    this.closeScanner = closeScanner;
    return () => {
      if (this.closeScanner === closeScanner) this.closeScanner = undefined;
    };
  }

  closeActiveScanner(): boolean {
    if (!this.closeScanner) return false;
    this.closeScanner();
    return true;
  }
}
